module.exports = __webpack_public_path__ + "static/media/sadigit.15b842e6.svg";